<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DB7ptE/tc-custom/9781637414019.jpg?1716662258246" alt="This image is the cover for the book Lebanese Food"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lebanese Food
      </h1>
      <p class="bookDescription body article font2">
        <b>“Even fussy eaters will enjoy. . . . Close-up color photographs of finished dishes give the cook good guidance to how the product should appear when served.” —<i>Booklist</i></b><br/>  <br/> Strongly rooted in the culinary traditions of the Middle East and the Mediterranean, Lebanese food draws on the exotic tastes of these two styles. These delicious, easy-to-make dishes—abounding in vegetables, fruits, yogurt, grains, and pungent spices—also are ideal for the health-conscious diner. And the recipes--from the scrumptious salads to the grilled kebabs—come from an author who learned them right in her grandmother's and mother's kitchens. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cassie Maroun-Paladin, John Peacock
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Holland Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23a90600